import { Traject } from "@/entities/dossier-details";
import { OpstartplanDto, OpstartplanTreinserieDto, TreinnummerDto } from "@/shared/types";
import { compareAsc, min } from "date-fns";

export type Opstartplan = {
    id: number;
    toelichting?: string;
    treinseries: Treinserie[];
};

export const Opstartplan = {
    fromDto: (dto: OpstartplanDto): Opstartplan => ({
        id: dto.id,
        toelichting: dto.toelichting,
        treinseries: dto.treinseries?.map(Treinserie.fromDto).sort(Treinserie.sort) ?? [],
    }),
    getFirstVertrekDatumTijd(opstartplan: Opstartplan) {
        return min(
            opstartplan.treinseries.flatMap((item) =>
                item.treinnummers.map((tn) => tn.vertrekDatumTijd).filter((vertrekTijd) => vertrekTijd !== undefined)
            )
        );
    },
};

export type Treinserie = {
    serie: number;
    treinnummers: Treinnummer[];
};

export const Treinserie = {
    sort: (a: Treinserie, b: Treinserie) => a.serie - b.serie,
    fromDto: (dto: OpstartplanTreinserieDto): Treinserie => ({
        serie: dto.treinserie,
        treinnummers: dto.treinnummers.map(Treinnummer.fromDto).sort(Treinnummer.sort),
    }),
    toDto: (treinserie: Treinserie): OpstartplanTreinserieDto => ({
        treinserie: treinserie.serie,
        treinnummers: treinserie.treinnummers.map(Treinnummer.toDto).sort((a, b) => {
            if (a.vertrekDatumTijd && b.vertrekDatumTijd) {
                return compareAsc(a.vertrekDatumTijd, b.vertrekDatumTijd);
            }
            return 0;
        }),
    }),
};

export type Treinnummer = {
    nummer: number;
    traject: Traject;
    vertrekDatumTijd?: Date | undefined;
};

export const Treinnummer = {
    fromDto: (dto: TreinnummerDto): Treinnummer => ({
        nummer: dto.nummer,
        traject: {
            vanStation: dto.traject.vanStation,
            naarStation: dto.traject.naarStation,
        },
        vertrekDatumTijd: dto.vertrekDatumTijd ? new Date(dto.vertrekDatumTijd) : undefined,
    }),
    toDto: (treinnummer: Treinnummer): TreinnummerDto => {
        if (treinnummer.vertrekDatumTijd == null) throw new Error("vertrekDatumTijd should have a value");
        return {
            nummer: treinnummer.nummer,
            traject: {
                vanStation: treinnummer.traject.vanStation,
                naarStation: treinnummer.traject.naarStation,
            },
            vertrekDatumTijd: treinnummer.vertrekDatumTijd.toISOString(),
        };
    },
    sort: (a: Treinnummer, b: Treinnummer) => {
        if (a.vertrekDatumTijd && b.vertrekDatumTijd) {
            return compareAsc(a.vertrekDatumTijd, b.vertrekDatumTijd);
        }
        return 0;
    },
};
